import { render, staticRenderFns } from "./FulfillmentForm.vue?vue&type=template&id=0ca088d9"
import script from "./FulfillmentForm.vue?vue&type=script&lang=js"
export * from "./FulfillmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports